import type { QueryClient } from '@tanstack/react-query';

/**
 * Query-key roots a sale makes stale (POS checkout, invoice signing). They
 * mirror `articleKeys.all`, `invoiceKeys.all`, `dashboardKeys.all` and
 * `stockKeys.all`, written raw because pos.ts and invoices.ts import this
 * file (importing their modules back would cycle). Prefix match.
 */
const SALE_AFFECTED_QUERY_ROOTS: readonly (readonly string[])[] = [
  ['articles'],
  ['invoices'],
  ['dashboard'],
  ['stock'],
];

/** Invalidates the caches a completed sale makes stale (see above). */
export function invalidateAfterSale(queryClient: QueryClient): void {
  for (const queryKey of SALE_AFFECTED_QUERY_ROOTS) {
    queryClient.invalidateQueries({ queryKey });
  }
}
